const URL_PATTERN = /((?:https?:\/\/|www\.)[^\s<>"')\]]+)/i;
const TRAILING_URL_PUNCTUATION = /[.,!?;:)]*$/;

export type FeedLinkSummary = {
  raw: string;
  url: string;
  host: string;
};

export function normalizeTypedUrl(value: string) {
  return value.startsWith("www.") ? `https://${value}` : value;
}

export function extractFirstFeedUrl(
  content: string | null | undefined,
): FeedLinkSummary | null {
  if (!content) return null;
  const match = content.match(URL_PATTERN);
  if (!match) return null;

  const rawMatch = match[0];
  const trailing = rawMatch.match(TRAILING_URL_PUNCTUATION)?.[0] ?? "";
  const raw = trailing
    ? rawMatch.slice(0, Math.max(0, rawMatch.length - trailing.length))
    : rawMatch;

  if (!raw) return null;

  try {
    const parsed = new URL(normalizeTypedUrl(raw));
    if (parsed.protocol !== "https:" && parsed.protocol !== "http:") {
      return null;
    }
    return {
      raw,
      url: parsed.toString(),
      host: parsed.hostname.replace(/^www\./, ""),
    };
  } catch {
    return null;
  }
}

export function compactPreviewText(
  value: string | null | undefined,
  maxLength = 120,
) {
  const normalized = value?.replace(/\s+/g, " ").trim();
  if (!normalized) return null;
  if (normalized.length <= maxLength) return normalized;

  const clipped = normalized.slice(0, Math.max(0, maxLength - 1)).trimEnd();
  const lastSpace = clipped.lastIndexOf(" ");
  const safeClip =
    lastSpace > Math.floor(maxLength * 0.55)
      ? clipped.slice(0, lastSpace)
      : clipped;
  return `${safeClip}…`;
}
